import { mswEnabled } from './toggles'

export const MSW_FORCE_STORAGE_KEY = 'msw:force'

/**
 * Persist ?force= from the page URL for MSW handlers.
 * Service workers cannot read window.location, so handlers use localStorage.
 * We only write when force is present so Auth0 redirects to /auth do not clear it.
 */
export function syncMswForceFlag () {
  if (typeof window === 'undefined' || !mswEnabled()) return

  const force = new URL(window.location.href).searchParams.get('force')
  if (!force) return

  try {
    localStorage.setItem(MSW_FORCE_STORAGE_KEY, force)
  } catch {
    // ignore quota errors
  }
}

/**
 * Resolve the active MSW scenario flag inside request handlers (incl. service worker).
 */
export function getMswScenarioFlag (request) {
  if (typeof window !== 'undefined') {
    const fromWindow = new URL(window.location.href).searchParams.get('force')
    if (fromWindow) return fromWindow
  }

  try {
    const fromStorage = localStorage.getItem(MSW_FORCE_STORAGE_KEY)
    if (fromStorage) return fromStorage
  } catch {
    // ignore
  }

  if (request?.url) {
    return new URL(request.url).searchParams.get('force')
  }

  return null
}
